/**
 * Downsample float32 audio to 16-bit PCM at 16 kHz for Flux STT.
 * Linear nearest-neighbour — good enough for a trial listen path.
 */

const OUT_RATE = 16000;

export function floatToPcm16(input: Float32Array, inRate: number, outRate = OUT_RATE): Int16Array {
  if (!input.length || !Number.isFinite(inRate) || inRate <= 0) return new Int16Array(0);
  const ratio = inRate / outRate;
  const outLen = Math.max(1, Math.floor(input.length / ratio));
  const out = new Int16Array(outLen);
  for (let i = 0; i < outLen; i += 1) {
    const sample = input[Math.min(input.length - 1, Math.floor(i * ratio))] ?? 0;
    const clipped = Math.max(-1, Math.min(1, sample));
    out[i] = clipped < 0 ? Math.round(clipped * 0x8000) : Math.round(clipped * 0x7fff);
  }
  return out;
}

export function concatFloat32(chunks: readonly Float32Array[]): Float32Array {
  const total = chunks.reduce((sum, chunk) => sum + chunk.length, 0);
  const out = new Float32Array(total);
  let offset = 0;
  for (const chunk of chunks) {
    out.set(chunk, offset);
    offset += chunk.length;
  }
  return out;
}
